var map = {
	"./en/adminAdministrators.json": 24959,
	"./es/adminAdministrators.json": 95673,
	"./fr/adminAdministrators.json": 59507,
	"./it/adminAdministrators.json": 220,
	"./pt-BR/adminAdministrators.json": 44534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30232;